import { DataBean } from "../DataBean";

export class CloseYearPeriod extends DataBean {

    public async closeYearPeriodForPyG(year: any, acountantIDStr: any, idBusinessCore: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_closeYearPeriodForPyG_Number_String_Number_Number", [year, acountantIDStr, idBusinessCore, idEmployee]);
    }

}